import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
//Limitless imports
import { PortalButton } from "@limitless/portal";
import SectionHeader from "../section-header/SectionHeader";
const useStyles = makeStyles(theme => ({
  buttonContainer: {
    ...theme.grid.gridTemplateContainer,
    paddingTop: "1%",
    justifyContent: "center",
    gridTemplateAreas: "'loginButton' 'optOutText'",
    width: "100%",
    gap: "16px 0px",
    paddingBottom: 40
  },
  checkboxesContainer: {
    paddingTop: "1%"
  },
  loginButton: {
    gridArea: "loginButton",
    display: "flex",
    justifyContent: "center"
  },
  optOutText: {
    gridArea: "optOutText"
  },
  contentContainer: {
    width: "100%"
  },
  [theme.breakpoints.up("sm")]: {
    contentContainer: {
      width: "80%"
    }
  },
  [theme.breakpoints.up("lg")]: {
    contentContainer: {
      width: "60%"
    },
    buttonContainer: {
      gridTemplateAreas: "'loginButton optOutText'",
      gap: "0px 16px",
      width: "auto",
      paddingLeft: 90
    }
  }
}));
const OptInCta = ({
  content,
  optInCtaClick,
  leftSpaceContainer,
  subHeaderContainer
}) => {
  var _content$checkboxes$f, _content$checkboxes;
  const checkboxesWithText = (_content$checkboxes$f = (_content$checkboxes = content.checkboxes) === null || _content$checkboxes === void 0 ? void 0 : _content$checkboxes.filter(({
    text
  }) => text !== "")) !== null && _content$checkboxes$f !== void 0 ? _content$checkboxes$f : [];
  const [checks, setChecks] = React.useState([...Array(checkboxesWithText.length)].map(() => false));
  const classes = useStyles();
  const validChecks = checks.filter(c => c === true);
  const handleChecksChange = index => {
    const checksCopy = [...checks];
    checksCopy[index] = !checksCopy[index];
    setChecks(checksCopy);
  };
  return /*#__PURE__*/React.createElement(Grid, {
    className: leftSpaceContainer
  }, /*#__PURE__*/React.createElement(SectionHeader, {
    header: content.header
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    className: `${subHeaderContainer} ${classes.contentContainer}`
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "textPrimary"
  }, content.subHeader), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    container: true,
    direction: "column",
    className: classes.checkboxesContainer
  }, checkboxesWithText.map((item, index) => {
    return /*#__PURE__*/React.createElement(FormControlLabel, {
      key: index,
      control: /*#__PURE__*/React.createElement(Checkbox, {
        color: "primary"
      }),
      label: /*#__PURE__*/React.createElement(Typography, {
        color: "textPrimary",
        variant: "body2"
      }, item.text),
      checked: item.checked,
      onChange: () => handleChecksChange(index)
    });
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    className: classes.buttonContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    className: classes.loginButton
  }, /*#__PURE__*/React.createElement(PortalButton, {
    onClick: () => optInCtaClick && optInCtaClick(true),
    disabled: validChecks.length !== checkboxesWithText.length
  }, content.buttonLabel)), /*#__PURE__*/React.createElement(Link, {
    underline: "none",
    component: "button",
    variant: "body1",
    color: "textPrimary",
    className: classes.optOutText,
    onClick: () => optInCtaClick && optInCtaClick(false)
  }, content.optOutText)))));
};
OptInCta.propTypes = {
  content: PropTypes.object.isRequired,
  optInCtaClick: PropTypes.func,
  leftSpaceContainer: PropTypes.string,
  subHeaderContainer: PropTypes.string
};
export default OptInCta;